module.exports = __webpack_public_path__ + "static/media/default.d78f770d.png";


//////////////////
// WEBPACK FOOTER
// ./src/carLeaseGuide/index/default.png
// module id = 1196
// module chunks = 0